import { render, staticRenderFns } from "./StoreInitializer.vue?vue&type=template&id=ba3c29c2&"
import script from "./StoreInitializer.vue?vue&type=script&lang=ts&"
export * from "./StoreInitializer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports